import {FormModel} from "./form.model.abstract";

/**
 * hiden field
 * @inheritDoc
 */
export class FormModelHidden extends FormModel {

  /**
   * @inheritDoc
   */
  public type = 'hidden';

  /**
   * @inheritDoc
   * @param id
   * @param value
   */
  constructor(id: string, value: any = null) {
    super(id, [], null, value, null);
  }

  /**
   * get a clone of the current object
   */
  public clone(): FormModelHidden {
    // @ts-ignore
    return new this.constructor(this.id, this.value);
  }
}
